import React from 'react';
import { FiTrendingUp, FiTrendingDown, FiDollarSign } from 'react-icons/fi';

const ReportCard = ({ 
  title, 
  value, 
  change,
  icon: Icon,
  color = 'blue',
  format = 'currency',
  description = '',
  isLoading = false
}) => {
  const colors = {
    blue: { bg: 'bg-blue-50', text: 'text-blue-600', iconBg: 'bg-blue-100' },
    green: { bg: 'bg-green-50', text: 'text-green-600', iconBg: 'bg-green-100' },
    orange: { bg: 'bg-orange-50', text: 'text-orange-600', iconBg: 'bg-orange-100' },
    purple: { bg: 'bg-purple-50', text: 'text-purple-600', iconBg: 'bg-purple-100' },
    red: { bg: 'bg-red-50', text: 'text-red-600', iconBg: 'bg-red-100' },
    gray: { bg: 'bg-gray-50', text: 'text-gray-600', iconBg: 'bg-gray-100' }
  };

  const { bg, text, iconBg } = colors[color] || colors.blue;

  const formatValue = (val) => {
    if (format === 'currency') {
      return new Intl.NumberFormat('en-NG', {
        style: 'currency',
        currency: 'NGN',
        minimumFractionDigits: 2
      }).format(val || 0);
    } else if (format === 'number') {
      return new Intl.NumberFormat().format(val || 0);
    } else if (format === 'percent') {
      return `${parseFloat(val || 0).toFixed(2)}%`;
    }
    return val;
  };

  return (
    <div className={`${bg} border border-gray-200 rounded-xl p-5 transition-all duration-200 hover:shadow-sm`}>
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-500">{title}</p>
          {isLoading ? (
            <div className="h-8 w-32 bg-gray-200 rounded animate-pulse mt-2"></div>
          ) : (
            <p className={`text-2xl font-bold ${text} mt-2`}>{formatValue(value)}</p>
          )}
          {description && !isLoading && (
            <p className="text-xs text-gray-500 mt-1">{description}</p>
          )}
        </div>
        
        {Icon && (
          <div className={`w-12 h-12 rounded-lg ${iconBg} flex items-center justify-center`}>
            <Icon className={`text-xl ${text}`} />
          </div>
        )}
      </div>
      
      {change !== undefined && !isLoading && (
        <div className="flex items-center text-sm pt-3 border-t border-gray-100">
          {change >= 0 ? (
            <FiTrendingUp className="text-green-500 mr-1" />
          ) : (
            <FiTrendingDown className="text-red-500 mr-1" />
          )}
          <span className={change >= 0 ? 'text-green-600' : 'text-red-600'}>
            {change >= 0 ? '+' : ''}{change.toFixed(2)}%
          </span>
          <span className="text-gray-500 ml-2">vs previous period</span>
        </div>
      )}
    </div>
  );
};

export default ReportCard;